import {Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TramiteItem} from "../../../../tramites/components/interfaces/tramites.interface";
import {EliminarTramiteService} from "../../../services/eliminar-tramite.service";
import {LoginServices} from "../../../../../auth/login/services/login.service";
import {TramiteService} from "../../../../tramites/services/tramite.service";
import Swal from "sweetalert2";
import {ButtonDirective} from "primeng/button";
import {DialogModule} from "primeng/dialog";
import {EditorModule} from "primeng/editor";
import {NgIf} from "@angular/common";
import {PrimeTemplate} from "primeng/api";
import {FormsModule} from "@angular/forms";
import {TooltipModule} from "primeng/tooltip";
import {UserSessionReq} from "../../../../../shared/interfaces/user-session-req-interface";
import {SdetInterface} from "../../../../tramites/components/interfaces/sdet.interface";
import {throwError} from "rxjs";
import {SdetTramiteService} from "../../../../tramites/services/sdet-tramite.service";

@Component({
  selector: 'app-seleccionar-tramite-dlg',
  standalone: true,
    imports: [
        ButtonDirective,
        DialogModule,
        EditorModule,
        NgIf,
        PrimeTemplate,
        FormsModule,
        TooltipModule
    ],
    providers:[],
  templateUrl: './seleccionar-tramite-dlg.component.html',
  styleUrl: './seleccionar-tramite-dlg.component.scss'
})
export class SeleccionarTramiteDlgComponent implements OnInit{
    @Input() visibleSeletedDlg = false;
    @Input() tramite!: TramiteItem;
    @Output() visibleChangeDlg = new EventEmitter<boolean>();
    @Output() onEventEmitterText = new EventEmitter<string>;
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    private quillEditor: any;
    comentarios = '';
    selecting = false;
    protected eliminarTramiteService = inject(EliminarTramiteService);
    private loginServices = inject(LoginServices);
    private tramiteService = inject(TramiteService);
    public solicitudDetService = inject (SdetTramiteService);

    ngOnInit(): void {
        console.log(
            `ngOnInit ->${this.constructor.name}` + new Date().toISOString()
        );
    }
    emitTextChange() {
        this.eliminarTramiteService.textChangeEditor.set(this.comentarios)
    }

    onEditorInit(event: any) {
        this.quillEditor = event.editor;

        const toolbar = this.quillEditor.getModule('toolbar');
        toolbar.addHandler('image', () => {
            this.fileInput.nativeElement.click();
        });

        this.quillEditor.on('text-change', () => {
            const contenidoEditor = this.quillEditor.root.innerHTML;
            const estaVacio = contenidoEditor === '<p><br></p>' || this.quillEditor.getText().trim() === '';
            this.eliminarTramiteService.textChangeEditor.set(contenidoEditor);
            if (estaVacio) {
                console.log('editor vacío seleccionar componente seleccionar tramite');
            }
        });
    }
    onImagenSeleccionada(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files[0]) {
            const file = input.files[0];
            const reader = new FileReader();

            reader.onload = () => {
                const base64 = reader.result as string;
                const range = this.quillEditor.getSelection(true);
                this.quillEditor.insertEmbed(range.index, 'image', base64);
                this.quillEditor.setSelection(range.index + 1);
                this.comentarios = this.quillEditor.root.innerHTML;
                this.eliminarTramiteService.textChangeEditor.set(this.quillEditor.root.innerHTML)
            };

            reader.readAsDataURL(file);
            input.value = '';
        }
    }

    confirm(): void {
        if (this.loginServices.isBotonSelectedValido()) {
            if (this.tramite == null) {
                console.log("datos de tramite son nulos");
                return;
            }
            Swal.fire({
                icon: "question",
                title: "¿Estas seguro de realizar acción de seleccionar trámite(s)?",
                html: `
                <ul style="text-align: left; font-size: 1.0rem; padding-left: 1.2em;">
                 <li>Al confirmar, se agrega trámite seleccionado.</li>
                  <li>Si la solicitud es de <b>tipo individual</b>, solo se agregar ese trámite.</li>
                  <li>Si la solicitud es de <b>tipo integrada</b> y el trámite pertenece a un grupo, se agregan todos los trámites de ese grupo.</li>
                  <li>Si la solicitud es de <b>tipo registro de profesional</b>, solo se agregar ese trámite.</li>
                  <li>Si el trámite había sido eliminado y se vuelve a seleccionar, se agrega con estado en carrito.</li>
                  <li>Si el trámite no tiene requisitos, se agrega con estado formulario completo.</li>
                  <li>Si el trámite no requiere pago, se agrega con estado no requiere pago.</li>
                </ul>
              `,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Sí, confirmar",
                denyButtonText: "No, cancelar",
                confirmButtonColor: "#28a745"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.agregarTramite(this.tramite);
                    this.selecting = true;
                }
            });

        }
    }

    cancel() {
        this.visibleSeletedDlg = false;
        this.selecting = false;
        this.visibleChangeDlg.emit(false);
        this.eliminarTramiteService.textChangeEditor.set(null);
    }
    agregarTramite(tramite: TramiteItem) {
        console.log("####################################################################")
        console.log(`agregarTramite->t:${JSON.stringify(tramite)}`)
        if (!this.tramiteService.selected()) {
            console.log("Proyecto es requerido para continuar");
            return
        }
        // this.loading.set(true)
        this.selecting = true;
        const currentSession: UserSessionReq = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        };
        const sdet: SdetInterface = {
            codigoInstitucion: tramite.codigoInstitucion ? parseInt(tramite.codigoInstitucion) : 0,
            idTramite: tramite.idTramite ? parseInt(tramite.idTramite) : 0,
            codigoProyecto: this.tramiteService.selected()!.idProyecto,
            codigoSolicitud: this.tramiteService.selected()!.idSolicitud,
            idFase: Number.parseFloat(tramite.idFase),
            usuario: currentSession.usuario,
            session: currentSession,
            idsTramites:tramite.idsTramites,
            comentario: this.eliminarTramiteService.textChangeEditor() != null ? this.eliminarTramiteService.textChangeEditor() : null
        };
        setTimeout(() => {//Timeout es requerido para mostrar animacion en pantalla.
            this.solicitudDetService.createSdet(sdet)
                .subscribe({
                    next: (resp) => {
                        if (resp) {
                            if (resp.status == 200 || resp.status == 201 || resp.status == 204) {
                                this.selecting = false;
                                this.visibleChangeDlg.emit(false);
                                // let idProyecto = resp.body! //esta variable esta vacia
                                // this.tramite.idProyecto.set(this.tramite.selected()!.idProyecto.toString()!)
                            }
                        }
                    },
                    error: (error) => {
                        // this.loading.set(false)
                        this.selecting = false;
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: error.error.mensaje,
                            showConfirmButton: true,
                            timer: 5000
                        })
                        return throwError(() => error);
                    },
                    complete: () => {
                        this.selecting = false;
                    }
                });
        }, 300);
    }

    ngOnDestroy() {
        console.log(`ngOnDestroy ->${this.constructor.name}` + new Date().toISOString());
        this.eliminarTramiteService.textChangeEditor.set(null);
    }
}
